<template>
<div id="app">
    <router-view></router-view>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import axios from "axios";

export default {
    name: "App",
    created() {
        var temp = this;

        //load categories for the navbar
		this.$store.dispatch("loadCategories");

        FingerprintJS.load().then(function (fp) {
            fp.get().then(function (result) {
                var visitorId = result.visitorId
                axios.get("/api/thumbprint?fingerprint=" + visitorId).then(function (response) {
                    temp.$store.dispatch("checkSession").then(function () {
                        if (temp.user.kolkinid) {
                            temp.$store.dispatch("loadLicenses")
                        }
                    });
                })
            })
        }).catch(function (error) {})
    },

    computed: {
        ...mapGetters(["user"])
    }
};
</script>

<style lang="css">

@import "../node_modules/video.js/dist/video-js.css";
@import 'vue-select/dist/vue-select.css';

</style>

<style lang="less">

@import './assets/less/style.less';
</style>
